module.exports = "<label class=\"file-upload-area {{disabled ? 'disabled-element' : ''}}\">\n  <span ng-if=\"!ngModel\">{{placeholder || \"Drag and drop a file here, or click to browse.\"}}</span>\n  <span ng-if=\"ngModel\">\n    <span class=\"chosen-file\">{{ngModel.name}}</span>\n    <span class=\"chosen-file-size\">{{hSize(ngModel.size)}}</span>\n  </span>\n  <input type=\"file\" name=\"file\" ng-disabled=\"disabled\" accept=\"{{accept}}\" />\n</label>\n"


//////////////////
// WEBPACK FOOTER
// ./src/directives/file-upload-input/file-upload-input.html
// module id = 471
// module chunks = 22